var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3248 2.33268C17.3248 1.41602 16.5832 0.666016 15.6665 0.666016H2.33317C1.4165 0.666016 0.666504 1.41602 0.666504 2.33268V12.3327C0.666504 13.2493 1.4165 13.9993 2.33317 13.9993H13.9998L17.3332 17.3327L17.3248 2.33268ZM13.1665 10.666H4.83317C4.37484 10.666 3.99984 10.291 3.99984 9.83268C3.99984 9.37435 4.37484 8.99935 4.83317 8.99935H13.1665C13.6248 8.99935 13.9998 9.37435 13.9998 9.83268C13.9998 10.291 13.6248 10.666 13.1665 10.666ZM13.1665 8.16602H4.83317C4.37484 8.16602 3.99984 7.79102 3.99984 7.33268C3.99984 6.87435 4.37484 6.49935 4.83317 6.49935H13.1665C13.6248 6.49935 13.9998 6.87435 13.9998 7.33268C13.9998 7.79102 13.6248 8.16602 13.1665 8.16602ZM13.1665 5.66602H4.83317C4.37484 5.66602 3.99984 5.29102 3.99984 4.83268C3.99984 4.37435 4.37484 3.99935 4.83317 3.99935H13.1665C13.6248 3.99935 13.9998 4.37435 13.9998 4.83268C13.9998 5.29102 13.6248 5.66602 13.1665 5.66602Z",
    fill: "#163567"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.2026d785d7227caab22279ded6d93400.svg";
export { ForwardRef as ReactComponent };